/**
 * Advanced Analytics (Mixpanel-like self-service) route paths.
 * Base: /advanced
 */
export const AdvancedAnalyticsRoutes = {
  INDEX: "/advanced",

  // Explorar (Reporte)
  FUNNELS: "/advanced/funnels",
  FLOWS: "/advanced/flows",
  RETENTION: "/advanced/retention",

  // Audiencias (Análisis)
  COHORTS: "/advanced/cohorts",
  COHORT_DETAIL: "/advanced/cohorts/:id",
  USERS: "/advanced/users",
  USER_PROFILE: "/advanced/users/:id",

  // Monitoreo
  BOARDS: "/advanced/boards",
  BOARD_DETAIL: "/advanced/boards/:id",
  REPORTS: "/advanced/reports",
  ALERTS: "/advanced/alerts",

  // Datos & Governance
  EVENTS: "/advanced/events",
  DICTIONARY: "/advanced/dictionary",
  GOVERNANCE: "/advanced/governance",
} as const;

export type AdvancedAnalyticsRoute =
  (typeof AdvancedAnalyticsRoutes)[keyof typeof AdvancedAnalyticsRoutes];
